export const PerformanceObserverEntryTypes = {
  LayoutShift: 'layout-shift',
  LongTask: 'longtask'
};